// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { useSubmissionDataGridContext } from '~/components/Forms/SubmissionDataGrid/SubmissionDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/Forms/SubmissionDataGrid/SubmissionDataGrid.utils';

export default function ResetSubmissionGridLink() {
    const { settings } = useSubmissionDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}            
        />
    );
}
